import React from "react";
import { Formik, Form } from "formik";
import { TextField } from "@mui/material"; // Use Material UI TextField directly
import { Box, Button, Grid, Typography, Avatar } from "@mui/material";
import "react-phone-input-2/lib/style.css";
import "./children-guide.css";
import * as Yup from "yup"; // For form validation

// Validation schema using Yup
const validationSchema = Yup.object().shape({
  cypName: Yup.string().required("CYP Name is required"),
  likes: Yup.string().required("likes is required"),
  dob: Yup.string().required("Date of Birth is required"),
});

const ChildrenGuide = ({ updateFormData, nextStep, prevStep }) => {
  return (
    <Box className='children-container-form'>
      {/* Top character */}
      <Box className='top-character'>
        <img src='./CYPImages/Ellipse.png' alt='top character' className='top-character-image' />
      </Box>
      <Box className='left-character'>
        <img src='./CYPImages/WormisConversations.png' alt='left character' className='left-character-image' />
      </Box>
      <Formik
        initialValues={{
          cypName: "",
          likes: "",
          dob: "",
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          updateFormData({ childrenGuideInfo: values });
          nextStep(); // Move to next form
        }}
        validateOnMount={false} // Do not validate on page reload or initial render
        validateOnBlur={true} // Validate on blur (when the user leaves the field)
      >
        {({ values, handleChange, handleBlur, handleSubmit, errors, touched }) => (
          <Box mt={8}>
            <Form onSubmit={handleSubmit} className='children-guide-form'>
              {/* Form Header */}
              <Typography
                variant='h4'
                className='form-title'
                sx={{ fontSize: "34px", fontFamily: "Love Ya Like A Sister", color: "#87028b", textAlign: "center" }}
              >
                {" "}
                Children'S Guide Data Fields's
              </Typography>
              <Typography
                variant='body2'
                className='form-subtitle'
                sx={{ textAlign: "center", mt: 1, fontSize: "14px" }}
              >
                Provide accurate details for the child or young person to ensure <br /> proper care and medical consent.
                Complete all fields and sign where <br />
                needed.
              </Typography>

              {/* Profile Avatar */}
              <Box
                className='avatar-box'
                sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: 4 }}
              >
                <Avatar
                  alt='Profile'
                  src='/images/person.png'
                  className='profile-avatar'
                  sx={{ width: 100, height: 100 }}
                />
                <Box mt={-8} mb={-5}>
                  <img src='./CYPImages/itsme.png' alt=' character' className='child' />
                </Box>
              </Box>

              {/* All About Me Section */}
              <Typography
                variant='h5'
                className='section-title'
                sx={{
                  fontSize: "22px",
                  fontFamily: "Love Ya Like A Sister",
                  color: "#ff5722",
                  textAlign: "center",
                  mt: 3,
                }}
              >
                All About Me
              </Typography>

              {/* Personal Information */}
              <Grid container mt={2}>
                <Grid item xs={12} lg={10}>
                  <Typography sx={{ fontWeight: "bold", fontSize: "14px", textAlign: "left" }}>My name is</Typography>
                  <TextField
                    fullWidth
                    placeholder='Enter your first name'
                    name='cypName'
                    value={values.cypName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.cypName && Boolean(errors.cypName)}
                    helperText={touched.cypName && errors.cypName}
                  />
                </Grid>
              </Grid>

              <Grid container mt={2}>
                <Grid item xs={12} lg={6}>
                  <Typography sx={{ fontWeight: "bold", fontSize: "14px", textAlign: "left" }}>
                    My birthday is
                  </Typography>
                  <TextField
                    fullWidth
                    name='dob'
                    type='date'
                    InputLabelProps={{ shrink: true }}
                    value={values.dob}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.dob && Boolean(errors.dob)}
                    helperText={touched.dob && errors.dob}
                  />
                </Grid>
              </Grid>

              {/* I Like Section */}
              <Grid container mt={4}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    placeholder='I Like .........'
                    name='likes'
                    multiline
                    rows={4}
                    value={values.likes}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.likes && Boolean(errors.likes)}
                    helperText={touched.likes && errors.likes}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#E1F5FE",
                        borderRadius: 2,
                        position: "relative",
                        marginBottom: "5px",
                        width: "100%",
                        border: "1px solid #ddd",
                        fontSize: "15px",
                      },
                    }}
                  />
                </Grid>
              </Grid>

              {/* Next Button */}
              <Box mt={3}>
                <Grid container justifyContent='space-between' alignItems='center' mt={2}>
                  <Grid item>
                    <Button type='button' variant='contained' color='primary' onClick={prevStep}>
                      Previous
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button type='submit' variant='contained' color='primary'>
                      Next
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Form>
          </Box>
        )}
      </Formik>
      {/* Bottom character */}
      <Box className='bottom-character'>
        <img src='./CYPImages/Wormis.png' alt='Bottom Character' className='bottom-character-image' />
      </Box>
    </Box>
  );
};

export default ChildrenGuide;
